import React from 'react';
import { Link } from 'react-router-dom';

const CARDS = [
  { title: 'Listen Live', to: '/listen', desc: 'Stream straight from the studio.' },
  { title: 'Ask Alexa', to: '/alexa', desc: 'Enable our skill: "Alexa, play OSO London".' },
  { title: 'Schedule', to: '/schedule', desc: 'Weekly programme and resident shows.' },
];

export default function HomeCards() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
      {CARDS.map((c) => (
        <Link
          key={c.to}
          to={c.to}
          className="hairline p-6 text-left hover:bg-white hover:text-black transition-colors duration-300 group"
        >
          <div className="text-[10px] font-mono-r tracking-[0.4em] uppercase opacity-70 group-hover:opacity-100">
            → {c.title}
          </div>
          <div className="font-display text-3xl mt-3">{c.title}</div>
          <div className="font-mono-r text-xs mt-3 opacity-80">{c.desc}</div>
        </Link>
      ))}
    </div>
  );
}
